import React from "react";
import {
  Box,
  Grid,
  Button,
  Typography
} from "@mui/material";
import {
  withStyles
} from "@mui/styles";
import {SectionInput} from "../MainInfo";

const CERTIFICATE_FIELDS = [
  {name: "certificate_stone", title: "Камень (как в сертификате)"},
  {name: "certificate_color", title: "Цвет (как в сертификате)"},
  {name: "certificate_processing", title: "Обработка (как в сертификате)"},
  {name: "certificate_origin", title: "Происхождение (как в сертификате)"},
  {name: "certificate_laboratory", title: "Лаборатория (как в сертификате)"},
  {name: "certificate_carats", title: "Караты (как в сертификате)"},
];

const EMPTY_CERTIFICATE = CERTIFICATE_FIELDS.reduce((acc, field) => {
  acc[field.name] = "";
  return acc;
}, {});

class Certificates extends React.PureComponent {
  addCertificate = () => {
    let values = {...this.props.values};
    values.certificates = [...(values.certificates || []), {...EMPTY_CERTIFICATE}];
    this.props.onChange(values);
  }

  deleteCertificate = (index) => {
    let values = {...this.props.values};
    const certificates = [...(values.certificates || [])];
    certificates.splice(index, 1);
    values.certificates = certificates;
    this.props.onChange(values);
  }

  changeField = (index, name, value) => {
    let values = {...this.props.values};
    const certificates = [...(values.certificates || [])];
    certificates[index] = {...certificates[index], [name]: value};
    values.certificates = certificates;
    this.props.onChange(values);
  }

  render () {
    const {
      values,
      classes
    } = this.props;

    const certificates = values.certificates || [];

    return (
      <Box className={classes.whiteSection}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h3">Сертификаты</Typography>
          </Grid>

          {certificates.map((certificate, index) => (
            <Grid item xs={12} key={`certificate-${index}`}>
              <Box className={classes.certificateCard}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Typography variant="h4">{`Сертификат №${index + 1}`}</Typography>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={this.deleteCertificate.bind(this, index)}
                      >
                        Удалить
                      </Button>
                    </Grid>
                  </Grid>

                  {CERTIFICATE_FIELDS.map((field) => (
                    <Grid item xs={12} key={field.name}>
                      <SectionInput
                        title={field.title}
                        value={certificate[field.name] || ""}
                        inputProps={{maxLength: 100}}
                        onChange={this.changeField.bind(this, index, field.name)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          ))}

          <Grid item xs={12}>
            <Button variant="contained" size="small" fullWidth onClick={this.addCertificate}>
              Добавить сертификат
            </Button>
          </Grid>
        </Grid>
      </Box>
    )
  }
}

const styles = {
  whiteSection: {
    backgroundColor: "white",
    borderRadius: "5px",
    padding: "10px 24px",
    boxSizing: "border-box",
  },
  certificateCard: {
    border: "1px solid #eaeaea",
    borderRadius: "5px",
    padding: "16px",
    boxSizing: "border-box",
  },
};
Certificates = withStyles(styles)(Certificates);

export default Certificates
